import http from '@/utils/http'

// 获取微信jsApiSignature
export function jsApiSignature(params) {
    return http.get("/api/authority/weixin/jsApiSignature", {
        params: params
    })
}
//弹窗接口
export function queryNoticeInfo() {
    return http.get("/api/weixin/queryNoticeInfo")
}
export function confirmRead(id) {
    return http.get("/api/weixin/confirmRead/" + id)
}
